import { types, flow, getRoot } from 'mobx-state-tree'
import { ConvertableDate } from 'store/types/date'
import { TRIGGER_TYPES } from 'constants/trigger.types'
import { Jurisdiction } from 'store/models/other/jurisdiction'
import { Tournament } from 'store/models/entities/tournament'
import { Team } from 'store/models/entities/team'

export const Event = types
  .model('EventModel', {
    id: types.identifierNumber,
    matchName: types.maybeNull(types.string),
    internalMatchId: types.maybeNull(types.string),
    binaryWinner: types.maybeNull(types.string),
    city: types.maybeNull(types.string),
    country: types.maybeNull(types.string),
    startTime: types.maybeNull(ConvertableDate),
    endTime: types.maybeNull(ConvertableDate),
    teamA: types.optional(types.string, ''),
    teamB: types.optional(types.string, ''),
    teamOne: types.maybeNull(Team),
    teamTwo: types.maybeNull(Team),
    resolverType: types.string,
    resolved: types.boolean,
    winner: types.maybeNull(types.string),
    tournament: types.reference(Tournament),
    jurisdiction: types.maybeNull(Jurisdiction),
    inWinnable: types.boolean,
    sportType: types.maybeNull(types.string),
  })
  .actions((self) => {
    const { triggers: triggersStore } = getRoot(self)

    return {
      loadTriggers: flow(function* (params) {
        const triggers = yield triggersStore.loadForEvent(self.id, params)
        return triggers
      }),
    }
  })
  .views((self) => ({
    get isBinary() {
      return self.resolverType === TRIGGER_TYPES.BINARY
    },
    get isCustomEvent() {
      return self.sportType === 'athletics' || self.sportType === 'other'
    },
  }))
